import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafetyGogglesPpe = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 6C24.448 6 24 6.448 24 7C24 7.552 24.448 8 25 8C26.654 8 28 9.346 28 11V13.003C27.164 12.374 26.125 12 25 12H7C5.875 12 4.836 12.373 4 13.003V11C4 9.346 5.346 8 7 8C7.552 8 8 7.552 8 7C8 6.448 7.552 6 7 6C4.243 6 2 8.243 2 11V19C2 22.86 5.14 26 9 26C11.718 26 14.177 24.419 15.325 22H16.675C17.823 24.419 20.282 26 23 26C26.86 26 30 22.86 30 19V11C30 8.243 27.757 6 25 6ZM23 24C20.885 24 18.991 22.66 18.285 20.667C18.144 20.268 17.766 20 17.342 20H14.656C14.232 20 13.854 20.267 13.713 20.667C13.008 22.661 11.113 24 8.998 24C6.241 24 3.998 21.757 3.998 19V17C3.998 15.346 5.344 14 6.998 14H24.998C26.652 14 27.998 15.346 27.998 17V19C27.998 21.757 25.755 24 22.998 24H23Z" />
	</svg>
);

export default SafetyGogglesPpe;
